/* EcoClean® — Panier : la boutique est en prix HT (TVA ajoutée au paiement). Sous le total HT du tiroir panier
   et de la page panier, on affiche le total TTC France estimé, pour que le client retrouve les prix TTC vus sur le site.
   Se met à jour à chaque changement du panier. Conçu par XRC · xrc.fr (01/10/2026) */
(function () {
  if (window.ecTaxesIncluded) return;
  var fmt = function (c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' }); };
  var timer = null, last = '';
  function apply() {
    var boxes = document.querySelectorAll('cart-drawer .totals, .cart__footer .totals');
    if (!boxes.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var html = c.item_count ? '<b>' + fmt(Math.round(c.total_price * 1.2)) + ' TTC</b> estimés · TVA 20 % ajoutée au paiement (France)' : '';
      boxes.forEach(function (t) {
        var h = t.querySelector('.totals__total'); if (h && !/HT/.test(h.textContent)) h.textContent = 'Total HT';
        var el = t.parentNode.querySelector('.ec-ttc-line');
        if (!el) { el = document.createElement('p'); el.className = 'ec-ttc-line'; t.insertAdjacentElement('afterend', el); }
        if (el.innerHTML !== html) el.innerHTML = html;
      });
      last = html;
    }).catch(function () {});
  }
  function soon() { clearTimeout(timer); timer = setTimeout(apply, 250); }
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) { var t = ms[i].target; if (t.classList && t.classList.contains('ec-ttc-line')) continue; if (t.closest && t.closest('cart-drawer, .cart__footer, #main-cart-footer, .drawer__footer')) { soon(); return; } }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', apply);
  if (document.readyState !== 'loading') apply();
})();